import React from 'react';
import Slider from 'react-slick';

// Import Slick styles
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Testimonials = ({ title, description, reviews }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
    ],
  };

  return (
    <section className="top-review bg-grey">
      <div className="container">
        <div className="section-title">
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
        <div className="review-wrap">
          <Slider {...settings}>
            {reviews.map((review) => (
              <div className="col-md-4 reviews-list align-center" key={review.id}>
                <div className="list-rv-detail">
                  <p className="mar-0">
                    <i className="fa fa-quote-left mar-right-10"></i> {review.text}
                  </p>
                </div>
                <div className="rev-author mar-top-40">
                  {/* <div className="rev-image">
                    <img src={review.image} alt={review.name} />
                  </div> */}
                  <div className="rev-content mar-left-20">
                    <h4 className="mar-bottom-5">{review.name}</h4>
                    <p className="mar-bottom-5">{review.role}</p>
                    <ul className="list-inline">
                      {[...Array(review.rating)].map((_, index) => (
                        <li key={index}>
                          <i className="fa fa-star text-warning"></i>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
